module.exports = __webpack_public_path__ + "static/assets/96cb5992a8e07340651badaa54393820.svg";